import { mediaUrl } from "../lib/api";
import { SecondaryAction } from "./kit";
import { OUTLINE_ACTION_STYLE } from "./SettingsSignOut";

/**
 * "Your details" on the face of Settings (#1135, the approved SettingsPlayer
 * and SettingsCoach boards): a 48px avatar, the name, the role line, the
 * contact line, and one outline button that opens the Edit your details sheet.
 *
 * Line two is `Player · <club>` (`Player` alone while the club is empty or
 * unread) or `Coach` alone: a coach has no club field (R5). Line three is
 * `<email> · <phone>`, the email alone when there is no phone.
 */
export default function SettingsDetailsCard({ user, club, onEdit }) {
  const isCoach = user?.role === "coach";
  const photo = mediaUrl(user?.profile_photo);
  const clubName = typeof club === "string" ? club.trim() : "";
  const role = isCoach ? "Coach" : clubName ? `Player · ${clubName}` : "Player";
  const contact = [user?.email, user?.mobile_phone].filter(Boolean).join(" · ");

  return (
    <div
      data-testid="settings-details"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        padding: 14,
        background: "var(--nw-surface)",
        border: "1px solid var(--nw-line)",
        borderRadius: "var(--nw-radius-card)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span
          data-testid="settings-details-avatar"
          style={{
            width: 48,
            height: 48,
            borderRadius: 999,
            background: "var(--nw-navy-tint)",
            border: "1px solid var(--nw-line-strong)",
            flexShrink: 0,
            overflow: "hidden",
          }}
        >
          {photo && <img src={photo} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />}
        </span>
        <div style={{ display: "flex", flexDirection: "column", gap: 2, flexGrow: 1, minWidth: 0 }}>
          <span
            data-testid="settings-details-name"
            style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: 16, color: "var(--nw-ink)", overflowWrap: "anywhere" }}
          >
            {user?.display_name || ""}
          </span>
          <span data-testid="settings-details-role" style={{ fontSize: 12, color: "var(--nw-ink-muted)", overflowWrap: "anywhere" }}>
            {role}
          </span>
          <span data-testid="settings-details-contact" style={{ fontSize: 12, color: "var(--nw-ink-muted)", overflowWrap: "anywhere" }}>
            {contact}
          </span>
        </div>
      </div>
      <SecondaryAction onClick={onEdit} data-testid="settings-edit-details" style={OUTLINE_ACTION_STYLE}>
        Edit your details
      </SecondaryAction>
    </div>
  );
}
